import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";
import BgImg from "../../images/services-usa/logistics-app/banner-logistics.webp";

function Banner(props) {
  return (
    <div
      className="service_usa web_dev_service healthcare_banner android_banner chatbot_banner"
      style={{
        backgroundImage: `url(${BgImg})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={9} lg={8} xl={7} xxl={7} className="my-auto">
            <div className="banenr_content">
              <h1 className="web_head_banner" style={{ marginBottom: "10px" }}>
                Logistics App Development Company
              </h1>
              <span>Custom, Use-Specific Logistics Applications</span>
              <p style={{ marginTop: "10px" }}>
                Conceptualize, design, and code high-end, feature-rich
                applications with our logistics app development company. With
                proven experience in the logistics industry, we offer custom
                solutions based on operational and process optimization needs to
                improve accessibility and accelerate turnarounds.
              </p>

              <Link
                to="/contact"
                className="border_btn"
                aria-label="TekRevol Contact"
              >
                Start with a Free Consultation
              </Link>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Banner;
